import React, { createContext, useContext, useState, ReactNode } from 'react';

interface BundleModalContextType {
  showBundleModal: boolean;
  openBundleModal: () => void;
  closeBundleModal: () => void;
}

const BundleModalContext = createContext<BundleModalContextType | undefined>(undefined);

export const BundleModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showBundleModal, setShowBundleModal] = useState(false);

  const openBundleModal = () => {
    setShowBundleModal(true);
  };

  const closeBundleModal = () => {
    setShowBundleModal(false);
  };

  return (
    <BundleModalContext.Provider 
      value={{ 
        showBundleModal, 
        openBundleModal, 
        closeBundleModal 
      }}
    >
      {children}
    </BundleModalContext.Provider>
  );
};

export const useBundleModal = () => {
  const context = useContext(BundleModalContext);
  if (context === undefined) {
    throw new Error('useBundleModal must be used within a BundleModalProvider');
  }
  return context;
};
